import {NDVSClient} from "../../client/NDVSClient";

export function asyncSetter({featureList}, setter) {
    NDVSClient.getFeaturesStatus({
        featureList : featureList
    }).then(({valid, data}) => {
        setter([valid, data.featureStatusMap]);
    });
}


// WEBPACK FOOTER //
// ./src/components/labelSheet/network/GetFeatureStatusAPI.js